export enum MomentDateFormat {
  Full = `MMM Do, YYYY`,
  Standard = `YYYY-MM-DD`,
}

export enum MomentUnit {
  Hour = `hours`,
  Day = `days`,
  Week = `weeks`,
  Month = `months`,
}
